import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormDataHistory, IGetConfig } from '@wdx/shared/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormHistoryInstanceService {
    constructor(private http: HttpClient, private config: IGetConfig) {}

    getHistoryInstance(
        formId: string,
        entityId: string,
        instanceId: string
    ): Observable<FormDataHistory> {
        return this.http.get<FormDataHistory>(
            `${
                this.config.getConfiguration().API_BASE
            }/formdata/${formId}/${entityId}/history/${instanceId}`
        );
    }
}
